import * as Yup from 'yup'
import passwordValidator from 'utils/validators/passwordValidator'

export const validationSchema = Yup.object().shape({
  token: Yup.string().required('common::validation_messages.required'),
  password: Yup.string()
    .test(
      'passwordValidator',
      'common::validation_messages.incorrect_password_format',
      passwordValidator,
    )
    .required('common::validation_messages.required'),
  /*password_repeat: Yup.string()
    .oneOf(
      [Yup.ref('password'), null],
      'auth::forms.recover_password.fields.password_repeat.errors.confirmMatch',
    )
    .required(
      'auth::forms.recover_password.fields.password_repeat.errors.confirmMatch',
    ),*/
})
